import MatrixGallery_MatrixGalleryLiftedShadowComponent from '../components/NativeGalleries/MatrixGallery/viewer/skinComps/MatrixGalleryLiftedShadow/MatrixGalleryLiftedShadow.skin';
import MatrixGallery_MatrixGalleryLiftedShadowController from '../components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.controller';


const MatrixGallery_MatrixGalleryLiftedShadow = {
  component: MatrixGallery_MatrixGalleryLiftedShadowComponent,
  controller: MatrixGallery_MatrixGalleryLiftedShadowController
};


export const components = {
  ['MatrixGallery_MatrixGalleryLiftedShadow']: MatrixGallery_MatrixGalleryLiftedShadow
};

